import './Styles.scss'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'primereact/dropdown'
import LayoutContainer from 'Components/LayoutComponent'
import { ButtonComponent, DialogModal } from 'Components/UIComponents'
import Loader from 'Components/Loader'
import apiAdapterCoffeeWeb from 'Services/apiAdapterCoffeeWeb'
import { getLocalAuthToken, setLocalWithjwtToken, getLocalJwtToken } from 'Utils/LocalStorageHandler'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

const ListOfAdmins = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [listOfAdmin, setListOfAdmin] = useState()
  const [selectedAdminId, setSelectedAdminId] = useState(null)
  const [showDialog, setShowDialog] = useState({ showModal: false, modalType: '', message: '', onHide: () => {}, onRetry: () => {}, onConfirmation: () => {}, onSuccess: () => {} })

  const authToken = getLocalAuthToken()

  useEffect(() => {
    const token = getLocalJwtToken()

    if (token) {
      history.push({
        pathname: ROUTE_STRINGS.coffeeCast
      })
    }

    fetchAdmins()
  }, [])

  const fetchAdmins = async () => {
    try {
      const { data } = await apiAdapterCoffeeWeb.getListOfAdmins()

      const admins = data?.map((user) => ({
        label: user.username,
        value: user.id
      }))

      setListOfAdmin(admins)
    } catch {
      setShowDialog({
        ...showDialog,
        showModal: true,
        modalType: 'error',
        message: t('FAILED_TO_LOAD_THE_LIST_OF_ADMINS'),
        onHide: handleDismiss
      })
    }
  }

  const handleSubmitButton = async () => {
    if (!selectedAdminId) return

    try {
      const payload = {
        externalUserId: String(selectedAdminId),
        apiKey: String(authToken),
        platformType: 'Web'
      }

      const { data } = await apiAdapterCoffeeWeb.postAdmin(payload)

      if (data) {
        setLocalWithjwtToken(data?.jwtToken)
        history.push({
          pathname: ROUTE_STRINGS.coffeeCast
        })
      }
    } catch {
      setShowDialog({
        ...showDialog,
        showModal: true,
        modalType: 'error',
        message: 'Failed To Generate Token',
        onHide: handleDismiss
      })
    }
  }

  const handleChange = (e) => {
    const selected = e.value

    setSelectedAdminId(selected)
  }

  const handleDismiss = () => {
    setShowDialog({ ...showDialog, showModal: false })
  }

  return (
    <LayoutContainer title={`${t('LIST_OF_ADMINS')}`} breadCrumbsTitle={'listOfAdmins'} showAddButton={false}>
      <div className="list-of-admins-container">
        <div className="dropdown-container">
          <Dropdown value={selectedAdminId} onChange={handleChange} options={listOfAdmin} optionLabel="label" placeholder="Select a user" className="drop-down" />
        </div>
        <div className="button-container">
          <ButtonComponent type="Custom" variant="action" label="Submit" onClick={handleSubmitButton} />
        </div>
      </div>
      <DialogModal {...showDialog} onDismiss={handleDismiss} />
    </LayoutContainer>
  )
}

export default Loader(ListOfAdmins)
